<template>
    <div class="d-flex flex-sm-row flex-column">
        <div v-if="canUse('config_tickets_action')==true"
             class="btn btn-outline-primary"
             :class="{'active':config_tickets_action == true}"
             @click="configTickets"
        ><i :class="nav_names.config.icon"></i>
            {{nav_names.config.button}}
        </div>
        <div v-if="canUse('override_tickets_action')==true"
             class="btn btn-outline-primary"
             :class="{'active':override_tickets_action == true}"
             @click="overRideTickets"
        ><i :class="nav_names.override.icon"></i>
            {{nav_names.override.button}}
        </div>
        <div v-if="canUse('order_tickets_action')==true"
             class="btn btn-outline-primary"
             :class="{'active':order_tickets_action == true}"
             @click="orderTickets"
        ><i :class="nav_names.order.icon"></i>
            {{nav_names.order.button}}
        </div>
        <div v-if="canUse('wastage_tickets_action')==true"
             class="btn btn-outline-danger"
             :class="{'active':wastage_tickets_action == true}"
             @click="wastageTickets"
        ><i :class="nav_names.wastage.icon"></i>
            {{nav_names.wastage.button}}
        </div>
    </div>
</template>

<script>
	// add imports here

	//ADD JSDOC HERE!!!!!
	export default {
		props: [
			'nav_names',
			'nav_restrictions',
			'config_tickets_action',
			'order_tickets_action',
			'override_tickets_action',
			'wastage_tickets_action'],
		created() {
		},
		destroyed() {
		},
		mounted() {

		},
		data() {
			return {
			    show_options :false
            }
		},
		methods: {

			configActive() {
				let _this = this;
				return [
					'order_tickets_action',
					'override_tickets_action',
					'wastage_tickets_action'
				].every(function (i) {
					return _this[i] == false;

				});
			},
			canUse(restriction) {
				if (this.nav_restrictions) {
					// is the restriction a property
                    if(_.has(this.nav_restrictions,restriction)){
                    	// console.log('canUse', 'restriction:'+restriction,this.nav_restrictions[restriction]);
                    	return !this.nav_restrictions[restriction];
                    }

				}
				// console.log('canUse', 'no restriction set for:' + restriction);
				return true;
			},
			configTickets() {
				this.$emit('nav_event', {
					action: 'config_tickets_action',
					toggle: this.nav_names.config.action == 'accordion'
				});
			},
			overRideTickets() {
				this.$emit('nav_event', {
					action: 'override_tickets_action',
					toggle: this.nav_names.override.action == 'accordion'
				});
			},
			orderTickets() {
				this.$emit('nav_event', {
					action: 'order_tickets_action',
					toggle: this.nav_names.order.action == 'accordion'
				});
				this.$emit('nav_event', {
					action: 'order_tickets_action',
					toggle: this.nav_names.order.action == 'accordion'
				});
			},
			wastageTickets() {
				this.$emit('nav_event', {
					action: 'wastage_tickets_action',
					toggle: this.nav_names.wastage.action == 'accordion'
				});
			},
		},
		computed: {}
	}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/pages/ticketing/EventTicketNav.vue?81257d64